// The depth configuration the runtime granted (2026-10-30, #5).
//
// Chrome 156 throws InvalidStateError when depthUsage / depthDataFormat are
// read on a session without depth sensing; earlier Chrome returned undefined.
// Reading them unconditionally failed every AR start on a phone that did not
// grant depth. Read only when granted, and a throwing getter is a null.

export interface GrantedDepthConfig {
  depthUsage: string | null
  depthDataFormat: string | null
}

function read(session: object, key: 'depthUsage' | 'depthDataFormat'): string | null {
  try {
    const value = (session as Record<string, unknown>)[key]
    return typeof value === 'string' ? value : null
  } catch {
    return null
  }
}

export function readGrantedDepthConfig(
  session: object,
  enabledFeatures: readonly string[],
): GrantedDepthConfig {
  if (!enabledFeatures.includes('depth-sensing')) {
    return { depthUsage: null, depthDataFormat: null }
  }
  return {
    depthUsage: read(session, 'depthUsage'),
    depthDataFormat: read(session, 'depthDataFormat'),
  }
}
